












































import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import { AxiosResponse } from 'axios'
import { ADD_TOAST_MESSAGE } from 'vuex-toast'
import { UserActionTypes } from '@/store/modules/users/actions'
import { UserScope } from '@/models/users'
import PaidLabel from '@/components/PaidLabel/PaidLabel.vue'
import UserAvatar from '@/components/User/UserAvatar.vue'
import UserRole from '@/components/User/UserRole.vue'

export default Vue.extend({
  components: {
    PaidLabel,
    UserAvatar,
    UserRole,
  },

  props: {
    user: {
      type: [Object],
      required: false,
      default() {
        return {}
      },
    },

    invitation: {
      type: [Object, Boolean],
      required: false,
      default: false,
    },
  },

  computed: {
    ...mapGetters(['canDoScope']),

    id(): string {
      return this.invitation ? this.invitation.id : this.user.id
    },

    fullname(): string {
      return this.invitation
        ? this.invitation.email
        : `${this.user.fname} ${this.user.lname}`
    },

    role(): string {
      return this.invitation ? this.invitation.role : this.user.role
    },

    phone(): string | undefined {
      return this.user?.phone
    },

    email(): string | undefined {
      return this.invitation ? this.invitation.email : this.user?.email
    },

    isSelf(): boolean {
      return this.user.id === this.$store.state.users.me.id
    },

    canProcessUser(): boolean {
      return (
        this.canDoScope(UserScope.Users) &&
        this.canDoScope(UserScope.Roles) &&
        !this.isSelf
      )
    },

    canDeleteUser(): boolean {
      return this.canProcessUser && this.user.active
    },

    canActivateUser(): boolean {
      return (
        this.invitation === false && this.canProcessUser && !this.user.active
      )
    },

    canCancelInvitation(): boolean {
      return !!this.invitation && this.canProcessUser
    },

    status(): string {
      if (this.invitation) {
        return this.$tc('user.status.invited')
      }
      if (this.user?.active) {
        return this.$tc('user.status.active')
      }
      return this.$tc('user.status.removed')
    },

    color(): 'success' | 'danger' | 'pending' {
      if (this.invitation) {
        return 'pending'
      }
      if (this.user?.active) {
        return 'success'
      }
      return 'danger'
    },
  },

  methods: {
    ...mapActions([
      UserActionTypes.Delete,
      UserActionTypes.CancelInvitation,
      UserActionTypes.Invite,
    ]),

    deleteUser() {
      this.$useConfirmDialog(
        [
          this.$tc('user.actions.removeConfirm'),
          {
            type: 'danger',
            okText: this.$tc('common.remove'),
            cancelText: this.$tc('common.cancel'),
          },
        ],
        () => {
          this[UserActionTypes.Delete](this.user.id).then(
            (response: AxiosResponse<boolean>) => {
              if (response.data) {
                this.$store.dispatch(ADD_TOAST_MESSAGE, {
                  text: this.$tc('user.actions.removeSuccess'),
                  type: 'info',
                })
              }
            },
          )
        },
      )
    },

    activateUser() {
      this.$useConfirmDialog(this.$tc('user.actions.repairConfirm'), () => {
        this[UserActionTypes.Invite]({
          email: this.email,
          role: this.role,
        })
      })
    },

    cancelInvitation() {
      this.$useConfirmDialog(this.$tc('user.actions.cancelConfirm'), () => {
        this[UserActionTypes.CancelInvitation]({
          email: this.invitation.email,
        }).then((response: AxiosResponse<boolean>) => {
          if (response.data) {
            this.$store.dispatch(ADD_TOAST_MESSAGE, {
              text: this.$tc('user.actions.cancelSuccess'),
              type: 'info',
            })
          }
        })
      })
    },
  },
})
